<template>
  <div class="dropdown-center">
    <button
      id="dropdowFlexDrivePrice"
      class="form-select form-select-short"
      type="button"
      data-bs-toggle="dropdown"
      aria-expanded="false">
      <div v-if="touched" class="form-select-wrapper">
        <div>
          <span>
            €{{ start.toLocaleString(lang) }} - €{{ end.toLocaleString(lang) }}
          </span>
        </div>
        <button
          type="button"
          class="btn btn-clear btn-reset"
          title="Clear"
          @click.stop="resetSelected">
          <i class="icon-close"></i>
        </button>
      </div>
      <div v-else>{{ dictionary.pricesPlaceholder }}</div>
    </button>
    <div class="dropdown-menu" aria-labelledby="dropdowFlexDrivePrice">
      <div class="b-fleet-filters" @click.stop>
        <div class="b-fleet-filters__body">
          <div class="d-flex justify-content-between">
            <span class="semibold">€{{ minValue?.toLocaleString(lang) }}</span>
            <span class="semibold">€{{ maxValue?.toLocaleString(lang) }}</span>
          </div>
          <VueSlider
            v-model="selected"
            v-bind="sliderOptions"
            :min="minValue"
            :max="maxValue"
            :interval="configuration.priceInterval"
            @change="onChange" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as lib from '../../../lib/lib'
import VueSlider from 'vue-slider-component'
import mixinsFlexDrive from './../../mixins/flexdrive-mixins'

export default {
  components: { VueSlider },
  mixins: [mixinsFlexDrive],
  props: {
    records: {
      required: true,
      type: Array,
    },
    minValue: { required: true, type: Number },
    maxValue: { required: true, type: Number },
  },
  emits: ['change-selected'],
  data() {
    return {
      lang: 'en',
      touched: false,
      selected: [],
      sliderOptions: {
        lazy: true,
        duration: null,
        height: 10,
        contained: true,
      },
    }
  },
  computed: {
    start() {
      return this.selected[0]
    },

    end() {
      return this.selected[1]
    },
  },
  mounted() {
    this.lang = lib.getLocaleFromLangAttr()

    this.selected = [this.minValue, this.maxValue]

    if (this.prices.length) {
      this.selected = this.prices
    }
  },
  methods: {
    resetSelected() {
      this.selected = [this.minValue, this.maxValue]
      this.onChange()
      // do not remove $nextTick
      this.$nextTick(() => {
        this.touched = false
      })
    },

    onChange() {
      // do not remove $nextTick
      this.$nextTick(() => {
        this.touched = true
        this.$emit('change-selected', this.selected)
      })
    },
  },
}
</script>
